import React, { useEffect, useState } from 'react';
import { fetchLargeGroundOrdersAP } from '../services/api';
import { toTitleCase } from '../utils/format';

/**
 * Orders > Large Ground Orders (AP): the admin portal list, $500 or more on 2-Day Ground, with its
 * Needs Reviewed and Cleared views. Azure exit WS8, built beside the existing Large Ground page
 * rather than over it, because that page works from a different review flag.
 */

// Local dates, not UTC: after 8 PM Eastern, toISOString() already says tomorrow.
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d); };
const showDate = (ymd) => {
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-');
  return `${m}/${d}/${y}`;
};

export default function LargeGroundAP({ navigateTo }) {
  const [from, setFrom] = useState(daysAgo(120));
  const [to, setTo] = useState(daysAgo(0));
  const [cleared, setCleared] = useState(false);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    fetchLargeGroundOrdersAP({ from, to, cleared })
      .then((r) => { if (live) setRows(r); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [from, to, cleared]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Large Ground Orders (AP)</h2>
      </div>
      <div className="port-filters">
        <input type="date" className="form-input" style={{ width: 'auto' }} value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" className="form-input" style={{ width: 'auto' }} value={to} onChange={(e) => setTo(e.target.value)} />
        <select className="form-select" style={{ width: 'auto' }} value={cleared ? 'cleared' : 'needs'} onChange={(e) => setCleared(e.target.value === 'cleared')}>
          <option value="needs">Needs Reviewed</option>
          <option value="cleared">Cleared</option>
        </select>
      </div>
      <div className="card">
        <div className="card-header">Orders{rows ? ` (${rows.length})` : ''}</div>
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!rows && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {rows && rows.length === 0 && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>No orders.</div>}
        {rows && rows.length > 0 && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead>
                <tr><th>Order Date</th><th>Order</th><th>Billing</th><th>Shipping</th><th>Amount</th><th>Delivery Date</th><th>Ship Method</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => navigateTo('order-details', r.bc_order_id || r.id)}>
                    <td>{showDate(r.order_date)}</td>
                    <td style={{ color: 'var(--orange)', fontWeight: 600 }}>{r.bc_order_id || r.id}</td>
                    <td>{toTitleCase(`${r.first_name || ''} ${r.last_name || ''}`)}<br />{r.city}, {r.state}</td>
                    <td>{toTitleCase(`${r.ship_first_name || ''} ${r.ship_last_name || ''}`)}<br />{r.ship_city}, {r.ship_state}</td>
                    <td>${Number(r.order_amount || 0).toFixed(2)}</td>
                    <td>{showDate(r.delivery_date)}</td>
                    <td>{r.ship_method}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}